
// ResetPass.tsx
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useState } from "react"
import { AuthLayout } from "@/components/layouts/AuthLayout"

interface ResetPassProps {
  onRememberPassword: () => void;
  onSubmit: () => Promise<void>;
  error?: string;
}

export function ResetPass({ onRememberPassword, onSubmit, error: propError }: ResetPassProps) {
  const [email, setEmail] = useState("");
  const [localError, setLocalError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await onSubmit();
      // Handle successful submission
    } catch (error) {
      setLocalError("Failed to send reset link");
    }
  };

  const displayError = propError || localError;

  return (
    <AuthLayout>
      <div className="p-8 rounded-2xl bg-gradient-to-br from-blue-500/10 via-transparent to-purple-500/10 border border-white/10">
        <h2 className="text-3xl font-bold text-white mb-6 text-center">Reset Password</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            placeholder="Email address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-black border-white/10 text-white placeholder:text-gray-400"
          />

          <div className="flex gap-4">
            <Button
              type="submit"
              className="flex-1 bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 hover:text-blue-300 transition-all duration-300"
            >
              Send Reset Link
            </Button>
            <Button
              type="button"
              onClick={onRememberPassword}
              className="flex-1 bg-purple-500/10 text-purple-400 hover:bg-purple-500/20 hover:text-purple-300 transition-all duration-300"
            >
              Back to Login
            </Button>
          </div>

          {displayError && (
            <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm">
              {displayError}
            </div>
          )}
        </form>
      </div>
    </AuthLayout>
  )
}